import {
  Button,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import {
  useHandleOnSearch, useRefreshDataWhenEnter,
} from './SearchActionHooks';
import { filterUndefined } from '../../../../utils/FilterUndefinedObject';

const defaultProps = {};

const SearchAction = (props) => {
  const { searchCriteria } = { ...defaultProps, ...filterUndefined(props) };
  const {
    courseId,
    unitId,
    topicId,
    lessonLevel,
  } = searchCriteria;

  const {
    handleOnSearch,
  } = useHandleOnSearch();

  useRefreshDataWhenEnter({
    handleOnSearch,
    searchCriteria,
  });
  return (
    <Button
      variant='contained'
      className='btn-primary search-button'
      onClick={() => { handleOnSearch({ searchCriteria }); }}
      disabled={!courseId || !unitId || !topicId || !lessonLevel}
      startIcon={<SearchIcon />}
      data-test='search-action'
    >
      Search
    </Button>
  );
};

export default SearchAction;
